import React from "react";
import { Testimonial } from "@scrile/api-provider/dist/api/TestimonialsProvider";
import { useTranslation } from "locales";
import TestimonialInfoCard from "./components/TestimonialInfoCard";
import TestimonialItem from "./components/TestimonialItem";
import useViewController from "./viewController";
import LandingSlider from "../LandingSlider";
import "./style.scss";

export default function BlockTestimonials() {
  const { t } = useTranslation();
  const { testimonials } = useViewController();

  const itemPrinter = (item: Testimonial) => <TestimonialItem item={item} />;

  const infoItems = [
    { title: "20-30%", description: t("Targeted uplift in offer conversion rates") },
    { title: "90%+", description: t("Student confidence and satisfaction post-coaching") },
    { title: "100%", description: t("Trusted by leading universities and business schools") },
  ];

  return (
    <div className="block-testimonials">
      <h2 className="block-testimonials__title h2 mb-4 text-center mx-auto">
        {t("Results universities can measure, and students can feel")}
      </h2>
      <div className="block-testimonials__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t(
          "Our partnerships with universities deliver measurable growth in key employment metrics, while giving students more than just skills—they gain a real competitive advantage for launching successful careers in finance."
        )}
      </div>

      <div className="block-testimonials__info gap-6 mb-6">
        {infoItems.map((i, index) => (
          <TestimonialInfoCard item={i} key={index} />
        ))}
      </div>

      <LandingSlider<Testimonial> list={testimonials} itemPrinter={itemPrinter} />
    </div>
  );
}
